<template>
    <div class="individual_detial" v-loading="loading">
        <div class="individual_detial_box">
             <div class="title_box">
                <!-- <img src="../../assets/img/login/Frame.png" alt=""> -->
                <span class="span1">首页</span> > <span class="span2">企业法务>法律文书>详情</span>
             </div>
             <div class="box_flex">
                <div class="box_left">
                    <div class="box1">
                        <div class="box1_top">
                            <div class="box1_banner">
                                <div class="banner_top">
                                    <img :src="banner_list[banner_ac]" alt="">
                                </div>
                                <div class="banner_bom">
                                    <div class="banner_btns" @click="handle_num_clear">
                                        <img src="../../../assets/img/index/legal/banner_left.png" alt="">
                                    </div>
                                    <div class="banner_list" ref="banner_list">
                                      <div class="banner_img" v-for="(item,index) in banner_list" :key="index" @click="handle_banner(item,index)" :class="{banner_img_ac:banner_ac==index}">
                                        <img :src="item" alt="">
                                      </div>  
                                    </div>
                                    <div class="banner_btns" @click="handle_num_add">
                                        <img src="../../../assets/img/index/legal/banner_right.png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="box1_info">
                                <div class="info_title_img">
                                    {{ individual_detial.title }}
                                    <img src="@/assets/img/index/legal/title_bg.png" alt="">
                                </div>
                                <div class="info_consts">
                                    {{ individual_detial.desc }}
                                </div>
                                <div class="info_tage">
                                    <div class="tages" v-if="(individual_detial.cate1||{}).title">{{ (individual_detial.cate1||{}).title }}</div>
                                    <div class="tages" v-if="(individual_detial.cate2||{}).title">{{ (individual_detial.cate2||{}).title }}</div>
                                    <div class="tages" v-if="(individual_detial.cate3||{}).title">{{ (individual_detial.cate3||{}).title }}</div>
                                </div>
                                <div class="info_price">
                                    <div class="price_title">价&nbsp;&nbsp;格</div>
                                    <div class="price_nums">￥{{ individual_detial.price }}</div>
                                </div>
                                <div class="info_form">
                                     <div class="form_flex">
                                        <div class="form_title">服务地区</div>
                                        <div class="form_input1">
                                            <el-cascader placeholder="请选择城市名称" clearable v-model="area_ac" :options="area_list"  :props="props" @change="handleChange"></el-cascader>
                                             
                                        </div>
                                     </div>
                                     <div class="form_flex">
                                        <div class="form_title">服务对象</div>
                                        <div class="form_input2">
                                            <div class="tege_list">
                                                <div class="teges teges_ac">企业</div>
                                            </div>
                                        </div>
                                     </div>

                                     <!-- <div class="form_flex">
                                        <div class="form_title">服务项目</div>
                                        <div class="form_input2">
                                            <div class="tege_list">
                                                <div class="teges" :class="{teges_ac:teges_ac==index}" v-for="(item,index) in fwxm_list" :key="index">{{ item.title }}</div>
                                            </div>
                                        </div>
                                     </div> -->
                                </div>
                                <div class="btn_flex">
                                    <div class="btns1" @click="handle_check(individual_detial,1)">在线委托</div>
                                    <div class="btns2" @click="handle_check(individual_detial,2)">预约律师</div>
                                </div>
                            </div>
                        </div>
                        <div class="box1_bom">
                            <div class="box1_bom_bg"></div>
                            <div class="bom_flex">
                                <div class="bom_lefts">
                                    服务承诺
                                </div>
                                <div class="bom_rights">
                                    <div class="img_text">
                                        <img src="../../../assets/img/index/legal/icon1.png" alt="">
                                        平台监控
                                    </div>
                                    <div class="borders"></div>
                                    <div class="img_text">
                                        <img src="../../../assets/img/index/legal/icon2.png" alt="">
                                        售后无忧
                                    </div>
                                    <div class="borders"></div>
                                    <div class="img_text">
                                        <img src="../../../assets/img/index/legal/icon3.png" alt="">
                                        极速退款
                                    </div>
                                    <div class="borders"></div>
                                    <div class="img_text">
                                        <img src="../../../assets/img/index/legal/icon4.png" alt="">
                                        官方保障
                                    </div>
                                    <!-- <div class="borders"></div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box2">
                        <div class="box2_tops">
                            <div class="check_type" :class="{check_type_ac:check_ac==index}" v-for="(item,index) in check_list" :key="index" @click="handle_ckeck(item,index)">
                                {{ item.title }}
                            </div>
                        </div>
                        <div class="htmls">
                            <div v-html="individual_detial.content" v-if="check_ac==0"></div>
                            <div v-html="individual_detial.content2" v-if="check_ac==1"></div>
                        </div>
                    </div>
                </div>
                <div class="box_right">
                    <legal_detial_new ref="legal_detial_new"></legal_detial_new>
                </div>
             </div>
        </div>
              
        <legal_check ref="legal_check"></legal_check>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
import legal_detial_new from '@/components/Legal/legal_detial_new.vue'//右边
 
import legal_check from '@/components/Legal/legal_check.vue'//选择

export default {
    components: {
        legal_detial_new,
        legal_check,
    },
    name: "homes",
    data() {
        return {
            loading:false,
            individual_detial:{},
            banner_ac:0,
            banner_img:'',
            banner_list:[
               
            ],
            value:'',
            options:[],
            teges_ac:0,
            fwxm_list:[
                {
                    title:'一审/仲裁',//
                },
                {
                    title:'二审/再审',//
                },
                {
                    title:'执行阶段',//
                }
            ],
            check_ac:0,
            check_list:[
                {
                    title:'服务介绍',
                },
                {
                    title:'服务流程',
                }
            ],
            //地区
            area_list: [],
            area_ac:[],
            props:{
                label:'name',
                value:'id',
                children:'children',
            },
        }
    },
    computed: {
       
    },
    watch: {
        banner_ac(newobj,oldobj){
            console.log('切换')
            this.$refs.banner_list.scrollTo({
                left: 90*(this.banner_ac-1),
                behavior: "smooth",
            })
            this.banner_img=this.banner_list[this.banner_ac].imgs
            // this.$refs.banner_list.scrollLeft=
        },
    },
    created() {
        this.get_detial()
        this.get_address()
    },
    methods: {
        get_address(){
            this.loading = true
            this.$api("getChinaArea", {
                parent_id:1,
                type:3,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址列表',res)
                if (res.code == 1) {
                    this.area_list=res.data
                   
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handleChange(e){
            console.log('e',e)
        },
        get_detial(){
            this.loading = true
            this.$api("serveProInfo", {
                id:this.$route.query.id
			}, "get").then((res) => {
                this.loading = false
                console.log('商品详情',res)
                if (res.code == 1) {
                   this.individual_detial=res.data
                   this.banner_list=res.data.images
                } else {
                    alertErr(res.msg)
                }
            });
        },
        //图片
        handle_banner(item,index){
            this.banner_ac=index
        },
        handle_num_clear(){
            if(this.banner_ac==0){

            }else{
                this.banner_ac--
            }
        },
        handle_num_add(){
            if((this.banner_list.length-1)==this.banner_ac){

            }else{
                this.banner_ac++
            }
        },
        handle_ckeck(item,index){
            this.check_ac=index
        },
        //咨询
        handle_check(item,i){
            this.$refs.legal_check.handle_open(item,i,1)
        },
    },

}
</script>
<style scoped lang="less">
.individual_detial{
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    padding:21px ;
    padding-bottom: 100px;
    .individual_detial_box{
        width: 1440px;
        margin: auto;
        .title_box{
            padding-bottom: 21px;

            display: flex;
            align-items: center;

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            .span1{
                cursor: pointer;
                margin-right: 10px;
            }
            .span2{
                cursor: pointer;
                margin-left: 10px;
            }
            img{
                margin-right: 10px;
            }
        }
        .box_flex{
            display: flex;
            // align-items: center;
            justify-content: space-between;
            .box_left{
                .box1{
                    width: 1000px;
                    // min-height: 605px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    .box1_top{
                        padding:30px 32px 24px 32px ;
                        display: flex;
                        .box1_banner{
                            width: 340px;
                            flex-shrink: 0;
                            .banner_top{
                                width: 340px;
                                height: 300px;
                            }
                            .banner_bom{
                                margin-top: 10px;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                .banner_btns{
                                    width: 20px;
                                    height: 56px;
                                    background: #F5F5F5;
                                    border-radius: 4px 0px 0px 4px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;
                                    img{
                                        width: 8px;
                                        height: 14px;
                                    }
                                }

                                .banner_list{
                                    width: 280px;
                                    overflow-x: scroll;
                                    display: flex;
                                    align-items: center;
                                    padding: 0 10px;
                                    margin: auto;
                                    .banner_img{
                                        width: 80px;
                                        height: 60px;
                                        margin-right: 10px;
                                        flex-shrink: 0;
                                        cursor: pointer;
                                        border-radius: 4px 4px 4px 4px;
                                        transition: all .5s ease;
                                        img{
                                            width: 80px;
                                            height: 56px;
                                            border-radius: 4px 4px 4px 4px;
                                            border: 2px solid #FFFFFF;

                                        }
                                    }
                                    .banner_img:last-child{
                                        margin-right: 0px;
                                    }
                                    &::-webkit-scrollbar {
                                        display: none;
                                    }
                                    .banner_img_ac{
                                        img{
                                            border: 1px solid #377CFD;
                                        }
                                    }
                                    
                                }
                            }
                        }
                        .box1_info{
                            padding-left: 24px;
                            .info_title_img{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 24px;
                                color: #333333;
                                img{
                                    width: 19px;
                                    height: 24px;
                                    margin-left: 10px;
                                }
                            }
                            .info_consts{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                padding-top: 24px;
                            }
                            .info_tage{
                                padding-top: 18px;
                                display: flex;
                                align-items: center;
                                .tages{
                                    padding: 4px 12px;
                                    background: #FDF6EC;
                                    border-radius: 3px 3px 3px 3px;
                                    border: 1px solid #FFAA00; 
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #FFAA00;
                                    margin-right: 10px;
                                }

                            }
                            .info_price{
                                width: 100%;
                                height: 64px;
                                background-image: url('../../../assets/img/index/legal/bg2.png');
                                background-size: 100%;
                                margin-top: 24px;
                                display: flex;
                                align-items: center;
                                padding: 0 24px;
                                .price_title{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #999999;
                                }
                                .price_nums{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 28px;
                                    color: #FD4C5C;
                                    padding-left: 16px;
                                }
                               
                            }
                            .info_form{
                                padding-top: 24px;
                                padding-bottom: 32px;
                                border-bottom: 1px solid #EEEEEE;
                                .form_flex{
                                    display: flex;
                                    align-items: center;
                                    margin-bottom: 16px;
                                    
                                    .form_title{
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #999999;
                                        padding-right: 16px;
                                    }
                                    .form_input1{
                                        width: 260px;
                                        /deep/.el-select{
                                            width: 260px;
                                        }
                                    }
                                    .form_input2{
                                        .tege_list{
                                            display: flex;
                                            align-items: center;
                                            flex-wrap: wrap;
                                            .teges{
                                                padding: 9px 26px;
                                                background: #FFFFFF;
                                                border-radius: 4px 4px 4px 4px;
                                                border: 1px solid #999999;
                                                font-family: Microsoft YaHei, Microsoft YaHei;
                                                font-weight: 400;
                                                font-size: 14px;
                                                color: #999999;
                                                cursor: pointer;
                                                margin-right:10px ;
                                            }
                                            .teges_ac{
                                                border: 1px solid #377CFD;
                                                color: #377CFD;
                                            }
                                        }
                                    }
                                }
                            }
                            .btn_flex{
                                display: flex;
                                align-items: center;
                                padding-top: 24px;
                                .btns1{
                                    width: 134px;
                                    height: 40px;
                                    background: #377CFD;
                                    border-radius: 4px 4px 4px 4px;
                                    border: 1px solid #377CFD;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #FFFFFF;
                                    text-align: center;
                                    line-height: 40px;
                                    cursor: pointer;
                                    margin-right: 10px;
                                }
                                .btns2{
                                    width: 134px;
                                    height: 40px;
                                    background: #FFFFFF;
                                    border-radius: 4px 4px 4px 4px;
                                    border: 1px solid #377CFD;
                                    line-height: 40px;
                                    text-align: center;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 14px;
                                    color: #377CFD;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                    .box1_bom{
                        position: relative;
                        width: 100%;
                        height: 60px;
                        .box1_bom_bg{
                            width: 100%;
                            height: 60px;
                            background: linear-gradient( 180deg, #377CFD 0%, #FFFFFF 60%, #FFFFFF 100%);
                            border-radius: 0px 0px 0px 0px;
                            opacity: 0.06;
                            position: absolute;
                            left: 0;
                            top: 0;
                        }
                        .bom_flex{
                            width: 100%;
                            height: 60px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 0 32px;
                            .bom_lefts{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #377CFD;
                            }
                            .bom_rights{
                                display: flex;
                                align-items: center;
                                .img_text{
                                    display: flex;
                                    align-items: center;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #666666;
                                    img{
                                        width: 14px;
                                        // height: 12px;
                                        margin-right: 5px;
                                    }
                                }
                                .borders{
                                    margin: 0 24px;
                                    width: 1px;
                                    height: 14px;
                                    background: #D7D7D7;
                                    border-radius: 0px 0px 0px 0px;
                                }
                            }
                        }
                        
                        
                    }
                }
                .box2{
                    background-color: #FFFFFF;
                    margin-top: 32px;
                    .box2_tops{
                        display: flex;
                        align-items: center;
                        width: 100%;
                        height: 60px;   
                        .check_type{
                            width: 120px;
                            height: 60px;   
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #666666;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                        }
                        .check_type_ac{
                            border-top: 3px solid #377CFD;
                            color: #377CFD;
                            background: #377CFD;
                            background-color:rgba(55, 124, 253, 0.04) ;
                        }   
                    }
                    .htmls{
                        padding: 20px;
                    }
                }
            }
        }
    }
}

</style>